import React, { useState } from "react";
import { Table, Input, Button, Popconfirm, Modal, Col, message } from "antd";
import { CompanyService } from "../services";
import { formatCurrency } from "utilities/currency";
const { TextArea } = Input;


const BulkUpload = ({history}) => {
    const [dataSource, setDataSource] = useState([]);
    const [requestedLimitJson, setRequestedLimitJson] = useState([]);
    const [bulkUpoadCases, setBulkUpoadCases] = useState(null);
    const [individualBulkCases, setIndividualBulkCases] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [casesSuccessModal, setCasesSuccessModal] = useState(false);
    const [casesSuccessMsg, setCasesSuccessMsg] = useState([]);
    
    
    const handleDelete = (case_id) => {
        setDataSource(prevDataSource => prevDataSource.filter(item => item.case_id !== case_id));
        const actualCaseIds = dataSource.filter(item => item.case_id !== case_id)?.map(el=>el.case_id);
        if(requestedLimitJson.length>0){
            const newRequestedLimitJson = requestedLimitJson.filter(el=>actualCaseIds.includes(el.case_id));
            setRequestedLimitJson([...newRequestedLimitJson]);
        }
    };

    const handleRequestedLimit = (e, value, record) => {
        
        const json_object = {
            "adhoc_limit_requested": e.target.value,
            "remarks":requestedLimitJson.find(el=>el["case_id"] === record.case_id)?.remarks || "",
            "case_id": record.case_id,
            "recommended_limit": record.recommended_limit ? formatCurrency(record.recommended_limit, false) : "--",
            "json_obj": {...record}
        };
        const otherRecords = requestedLimitJson.filter(el=>el.case_id !== record.case_id);
        if(requestedLimitJson.length>0){
            setRequestedLimitJson([...otherRecords, json_object]);
        }
        setRequestedLimitJson([...otherRecords, json_object]);
    };

    const handleRemarks = (e,value, record) => {
        const json_object = {
            "adhoc_limit_requested": requestedLimitJson.find(el=>el["case_id"] === record.case_id).adhoc_limit_requested || "",
            "remarks": e.target.value,
            "case_id": record.case_id,
            "recommended_limit": record.recommended_limit ? formatCurrency(record.recommended_limit, false) : "--",
            "json_obj": {...record}
        };
        const otherRecords = requestedLimitJson.filter(el=>el.case_id !== record.case_id);
        if(requestedLimitJson.length>0){
            setRequestedLimitJson([...otherRecords, json_object]);
        }
        setRequestedLimitJson([...otherRecords, json_object]);
    };

    const columns = [
        {
            title: "Case ID",
            dataIndex: "case_id",
            key: "case_id",
            width: 100,
            align: "center",
        },
        {
            title: "Category",
            dataIndex: "category",
            key: "category",
            width: 100,
            align: "center",
        },
        {
            title: "Recommended Limit",
            dataIndex: "recommended_limit",
            key: "recommended_limit",
            width: 200,
            align: "center",
            render(text) {
                return {
                    children:
              text && typeof text === "number" ? "₹"+formatCurrency(text, false) : "--",
                };
            }
        },
        {
            title: "Requested Limit",
            dataIndex: "requested_limit",
            key: "requested_limit",
            width: 200,
            align: "center",
            render: (value, record) =>{
                return( <Input
                    placeholder="Requested Limit"
                    type="number"
                    value={dataSource.find(el=>el.case_id === record.case_id) ? requestedLimitJson.find(el=>el.case_id === record.case_id)?.adhoc_limit_requested : ""}
                    onChange={(e) => handleRequestedLimit(e, value, record)}
                />);}
        },
        {
            title: "Remarks",
            dataIndex: "remarks",
            key: "remarks",
            width: 200,
            align: "center",
            render: (value, record) =>{
                return( <Input
                    placeholder="Remarks"
                    value={dataSource.find(el=>el.case_id === record.case_id) ? requestedLimitJson.find(el=>el.case_id === record.case_id)?.remarks : ""}
                    onChange={(e) => handleRemarks(e, value, record)}
                />);}
        },
        {
            title: "Action",
            dataIndex: "operation",
            key: "operation",
            width: 200,
            align: "center",
            render: (text, record) =>{
                return(
                    dataSource.length >= 1 ? (
                        <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.case_id)}>
                            <a>Delete</a>
                        </Popconfirm>
                    ) : null);},
        },
    ];

    const handleBulkUpload = () => {
        const case_ids = bulkUpoadCases && bulkUpoadCases.trim().split("\n").join(",");
        case_ids.length>0 && CompanyService.getAdhocBulkCasesLimit(case_ids).then(res=>{
            if(res.status === 200){
                const  allCaseIds= case_ids.split(",");
                const foundCaseIds = res.data?.results?.map(el=>el.case_id);
                const notFoundCaseIDs = allCaseIds.filter((value) => !foundCaseIds.includes(value)).join(", ");
                notFoundCaseIDs.length>0 && message.error(`Case IDs ${notFoundCaseIDs} not found in Pre-approved case list`, 4);
                setDataSource(prev=> {
                    const uniqueObjects = [];
                    const seenCaseIds = {};
                    const totalData = [ ...prev,...res.data?.results];
                    for (const obj of totalData) {
                        if (!seenCaseIds[obj.case_id]) {
                            seenCaseIds[obj.case_id] = true;
                            uniqueObjects.push(obj);
                        }
                    }
                    return( [...uniqueObjects]);});
            }
        }).catch((err) => {
            message.error("Something went wrong");
        });
        setBulkUpoadCases(null);
    };
    const handleBulkSubmit = () => {
        const body = [...requestedLimitJson];
        if (isSubmitting) {
            return;
        }
        setIsSubmitting(true);
        if(body.length !== dataSource.length){
            setIsSubmitting(false);
            message.error("Please fill all the fields");
            return;
        }
        // const incorrectReqLimitCaseIDs = body.filter(el=>Number(el.adhoc_limit_requested) <=0 || Number(el.adhoc_limit_requested)>Number(el.recommended_limit.replace(/,/g, "")))?.map(el=>el.case_id);
        const emptyRemarksCaseIDs = body.filter(el=> !el.remarks)?.map(el=>el.case_id)?.join();
        // if(incorrectReqLimitCaseIDs.length>0){
        //     message.error(`Please fill correct requested limits in Case-IDs: ${incorrectReqLimitCaseIDs}` || "Please fill correct requested limits");
        //     setIsSubmitting(false);
        //     return;
        // }
        if(emptyRemarksCaseIDs){
            setIsSubmitting(false);
            message.error(`Please fill remarks for Case-IDs: ${emptyRemarksCaseIDs}` || "Please fill all the remarks");
            return;
        }
        if(requestedLimitJson.length===0){
            setIsSubmitting(false);
        }
        if(body?.length>0){
            for (const item of body) {
                const recommendedLimit = parseFloat(item.recommended_limit.replace(/,/g, ""));
                item.recommended_limit = recommendedLimit;
            }
        }
        requestedLimitJson.length>0 && CompanyService.submitAdhocBulkCasesLimit(body).then(res=>{
            setIsSubmitting(false);
            if(res.status === 200){
                setDataSource([]);
                setRequestedLimitJson([]);
                setCasesSuccessModal(true);
                setCasesSuccessMsg(res.data && res.data.already_exist_adhoc);
            }
        }).catch((err) => {
            setIsSubmitting(false);
            console.log("inside res err", err);
            message.error("Something went wrong");
        });
    };
    
    const handleOk = () => {
        setIsModalOpen(false);
    };
    
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const addAdhocCaseFn = () => {
        setIsModalOpen(false);
        CompanyService.getAdhocBulkCasesLimit(individualBulkCases).then(res=>{
            if(res.status === 200){
                setIndividualBulkCases(null);
                setDataSource(prev=>  [...prev , ...res.data?.results]);
            }
        }).catch((err) => {
            message.error("Something went wrong");
        });
    };
    const closeModalFn = () => {
        setCasesSuccessModal(false);
        setCasesSuccessMsg([]);
    };
    return (
        <React.Fragment>
            <Col span={24} className={"p-5"}>
                <div className="d-flex justify-content-space-between align-items-center mb-10" style={{width:"100%", margin:"auto"}}>
                    <div style={{width:"20%"}}>
                        <Button onClick={() => history.replace( "/app/adhoc" )} type="primary">
                    Back
                        </Button>
                    </div>
                    <div style={{width:"70%"}} className="d-flex justify-content-space-between align-items-center">
                        <div>
                            <TextArea value={bulkUpoadCases} allowClear placeholder="Enter Bulk Case IDs" rows={2} autoSize={{ minRows: 3, maxRows: 5 }} onChange={e => setBulkUpoadCases(e.target.value)}/>
                        </div>
                        <Button disabled={!bulkUpoadCases} onClick={handleBulkUpload} type="primary">Add Cases</Button>
                    </div>
                    <div style={{width:"20%"}}>
                    </div>
                </div>
                <Col className={"p-5 d-flex flex-column justify-content-center align-items-center mt-10"} style={{width:"60%", margin:"auto"}}>
                    <Table 
                        size="middle"
                        bordered 
                        dataSource={dataSource} 
                        columns={columns} 
                        pagination={false}
                        scroll={{ y: 480 }}
                        className={"inbox-table"}
                    />
                    <Button style={{width:"25%", height:"2rem"}} disabled={isSubmitting} className="mt-10" size={"small"} onClick={handleBulkSubmit} type="primary">Submit</Button>
                </Col>
            </Col>
            <Modal title="" visible={isModalOpen} onOk={handleOk} onCancel={handleCancel} destroyOnClose={true} closable={true} footer={null}>
                <div className="d-flex flex-column justify-content-center align-items-center">
                    <div className="d-flex justify-content-center w-100 mb-10">
                        <Input size="medium" placeholder="Add Case ID" style={{width:"40%"}} value={individualBulkCases} onChange={e => setIndividualBulkCases(e.target.value)} />
                    </div>
                    <Button type="primary" style={{width:"25%", height:"2rem"}} disabled={!individualBulkCases} onClick={addAdhocCaseFn}>Submit</Button>
                </div>
            </Modal>
            <Modal title={`Could Not Request ${casesSuccessMsg.length} Cases`} onCancel={()=>closeModalFn()} visible={casesSuccessModal} destroyOnClose={true} closable={true} footer={null}>
                <div className="displayInline w-100">
                    <div className="mb-20">
                        {casesSuccessMsg.map((el,id)=><p style={{color:"red"}} key={id}> {el.error}</p>
                        )}
                    </div>
                    <Button type="primary" className="float-right" onClick={()=>closeModalFn()}>OK</Button>
                </div>
            </Modal>
        </React.Fragment>
    );
};

export default BulkUpload;
